import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { MatLegacySlider, MatLegacySliderChange } from '@angular/material/legacy-slider';
import { BehaviorSubject } from 'rxjs';
import { DOWN_ARROW, hasModifierKey, UP_ARROW } from "@angular/cdk/keycodes";

@Component({
  selector: 'mm-przewijany-komponent',
  templateUrl: './przewijany-komponent.component.html',
  styleUrls: ['./przewijany-komponent.component.scss']
})
export class PrzewijanyKomponentComponent implements AfterViewInit, OnDestroy {

  @ViewChild('component') componentRef!: ElementRef;
  @ViewChild('suwak') suwak!: MatLegacySlider;

  @Input() czyBlokowacKlikniecie = false;
  @Input() wysokoscSuwaka = '100';

  @Input() stylBialy = false;

  @Output() osiagnietoKoniec = new EventEmitter();
  @Output() zmianaWidocznosci = new EventEmitter<boolean>();

  czySuwakWidoczny$ = new BehaviorSubject(false);
  private licznik = 0;
  private intervalId: any;
  private poprzedniStan = false;

  constructor(private detektorZmian: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.licznik = 0;
    this.ustawWidocznoscSuwaka(null);
    this.detektorZmian.detectChanges();
    this.nadpiszEventKeyDownSuwaka();
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.licznik = 0;
  }

  nadpiszEventKeyDownSuwaka() {
    this.suwak._onKeydown = (event: any) => {
      if (this.suwak.disabled || hasModifierKey(event)) {
        return;
      }
      const oldValue = this.suwak.value;
      switch (event.keyCode) {
        case UP_ARROW:
          this.suwakIncriment(-1);
          break;
        case DOWN_ARROW:
          this.suwakIncriment(1);
          break;
        default:
          return;
      }
      if (oldValue != this.suwak.value) {
        this.suwak.input.emit(this.suwakCreateChangeEvent(this.suwak.value));
      }
      this.suwak._isSliding = 'keyboard';
      event.preventDefault();
    };
  }

  suwakCreateChangeEvent(value: any) {
    let event = new MatLegacySliderChange();
    event.source = this.suwak;
    event.value = value;
    return event;
  }

  suwakIncriment(numSteps: number) {
    this.suwak.value = this.suwakClamp(
      (this.suwak.value || 0) + this.suwak.step * numSteps,
      this.suwak.min,
      this.suwak.max
    );
  }

  suwakClamp(value: any, min = 0, max = 1) {
    return Math.max(min, Math.min(value, max));
  }

  przewijanie(): void {
    if (!this.suwak) {
      return;
    }
    const dlugoscSuwaka =
      this.componentRef.nativeElement.scrollHeight -
      this.componentRef.nativeElement.offsetHeight;

    this.suwak.value = Math.round(
      100 * this.componentRef.nativeElement.scrollTop / dlugoscSuwaka
    );

    this.detektorZmian.detectChanges();

    if (dlugoscSuwaka <= Math.ceil(this.componentRef.nativeElement.scrollTop)) {
      this.osiagnietoKoniec.emit();
    }
  }

  przewinNaKoniec(): void {
    if (!this.suwak) {
      return;
    }
    const dlugoscSuwaka =
      this.componentRef.nativeElement.scrollHeight -
      this.componentRef.nativeElement.offsetHeight;

    this.suwak.value = 100;
    this.zmianaSuwaka({ value: 100 });

    this.detektorZmian.detectChanges();

    if (dlugoscSuwaka <= Math.ceil(this.componentRef.nativeElement.scrollTop)) {
      this.osiagnietoKoniec.emit();
    }
  }

  przewinNaPoczatek(): void {
    if (!this.suwak) {
      return;
    }
    this.suwak.value = 0;
    this.zmianaSuwaka({ value: 0 });
    this.detektorZmian.detectChanges();
  }

  zmianaSuwaka(wartoscPolozenia: any): void {
    this.componentRef.nativeElement.scrollTop =
      Math.round(
        wartoscPolozenia.value *
        (this.componentRef.nativeElement.scrollHeight -
          this.componentRef.nativeElement.offsetHeight) / 100
      );
  }

  ustawWidocznoscSuwaka(zmiana: any | null): void {
    const czyWidoczny = this.czySuwakPotrzebny();

    this.czySuwakWidoczny$.next(czyWidoczny);
    this.zmianaWidocznosci.emit(czyWidoczny);

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = setInterval(() => {
      const czyWidoczny = this.czySuwakPotrzebny();
      this.licznik++;
      this.czySuwakWidoczny$.next(czyWidoczny);
      this.zmianaWidocznosci.emit(czyWidoczny);
    }, 10);
  }

  blokujEmitowanieClick(event: MouseEvent) {
    if (this.czyBlokowacKlikniecie) {
      event.preventDefault();
      event.stopPropagation();
    }
  }


czySuwakPotrzebny(): boolean {
  const el = this.componentRef?.nativeElement;

  if (!el) {
    return false;
  }

  const roznica = el.scrollHeight - el.clientHeight;

  // jeśli już był widoczny, ukrywaj dopiero poniżej 1px
  if (this.poprzedniStan) {
    this.poprzedniStan = roznica > 15;
  }
  // jeśli był ukryty, pokazuj dopiero powyżej 5px
  else {
    this.poprzedniStan = roznica > 15;
  }

  return this.poprzedniStan;
}
}

